(function(){
var DATA=window.DHTMN_DATA||[];var BASE="/collections/";
var bar=null,current=null,hideT=null,pointerInPanel=false,wired=false;
function el(t,c,h){var e=document.createElement(t);if(c)e.className=c;if(h!=null)e.innerHTML=h;return e;}
function esc(s){return String(s).replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;");}
function n(v){return v>0?'<span class="dhtmn-n">'+v+'</span>':'';}
function slug(s){return String(s==null?"":s).toLowerCase().replace(/[^a-z0-9]+/g,"-").replace(/^-+|-+$/g,"");}
/* The row scrolls instead of clipping, but the scrollbar is hidden to keep the
   bar's line, so the only cue that more departments exist is the edge fade in
   dht-meganav.css. Toggle it per side, and only when the row really overflows:
   a permanent fade would dim the last department at widths where all nine
   already fit. Queries fresh rather than closing over `inner`, because
   inject() runs again after a header section reload. */
function scrollCue(){
  var b=document.querySelector(".dhtmn-bar");
  var i=b&&b.querySelector(".dhtmn-inner");
  if(!b||!i)return;
  var max=i.scrollWidth-i.clientWidth;
  b.classList.toggle("dhtmn-more-end",max>1&&i.scrollLeft<max-1);
  b.classList.toggle("dhtmn-more-start",max>1&&i.scrollLeft>1);
}
function panelHTML(dep){
var h='<div class="dhtmn-panel__in"><div class="dhtmn-head"><h3>'+esc(dep.n)+'</h3><a href="'+BASE+dep.h+'">View all &#9656;</a></div><div class="dhtmn-cols">';
var cats=dep.s||[];
if(!cats.length){h+='<div class="dhtmn-blk"><a class="dhtmn-cat" href="'+BASE+dep.h+'">Browse all '+esc(dep.n)+'</a></div>';}
cats.forEach(function(cat){var subs="";(cat.x||[]).forEach(function(x){subs+='<li><a href="'+BASE+x.h+'">'+esc(x.n)+n(x.c)+'</a></li>';});
h+='<div class="dhtmn-blk"><a class="dhtmn-cat" href="'+BASE+cat.h+'">'+esc(cat.n)+n(cat.c)+'</a>'+(subs?'<ul>'+subs+'</ul>':'')+'</div>';});
h+='</div></div>';return h;}

/* --- open/close ------------------------------------------------------- */
/* Every close path funnels through hide() so the visual state (display,
   .open) and the assistive state (aria-expanded on the trigger, aria-hidden
   on the panel) can never drift apart. */
function hide(rec){rec.panel.style.display="none";rec.panel.setAttribute("aria-hidden","true");rec.item.classList.remove("open");rec.btn.setAttribute("aria-expanded","false");}
function closeNow(){if(!current)return;hide(current);current=null;pointerInPanel=false;}
function focusInside(){if(!current)return false;var a=document.activeElement;return !!a&&(current.item.contains(a)||current.panel.contains(a));}
/* The hover timer must not yank the panel out from under a keyboard user: a
   stray mouse movement across the bar used to fire mouseleave while focus was
   sitting on a link inside the open panel. Mouse-driven closes therefore defer
   to focus; deliberate closes (Escape, resize, search opening) call closeNow. */
function closeSoft(){if(focusInside())return;closeNow();}
function scheduleClose(){clearTimeout(hideT);hideT=setTimeout(closeSoft,140);}
function keep(){clearTimeout(hideT);}
/* Only one header overlay at a time: the search dropdown and a mega panel both
   drop out of the header and would sit on top of each other. */
function closeSearch(){var s=document.querySelector("predictive-search[open]");if(s&&typeof s.close==="function")s.close();}
/* The panel is position:fixed, so its top has to be re-pinned to the live
   bottom edge of the bar every time it is shown or the page scrolls under it. */
function position(panel){panel.style.top=Math.round(bar.getBoundingClientRect().bottom)+"px";}
function openP(item,panel,btn){clearTimeout(hideT);closeSearch();if(current&&current.item!==item)hide(current);
position(panel);panel.style.display="block";panel.setAttribute("aria-hidden","false");item.classList.add("open");btn.setAttribute("aria-expanded","true");current={item:item,panel:panel,btn:btn};}
function links(panel){return panel.querySelectorAll("a[href]");}
function closeToTrigger(){if(!current)return;var b=current.btn;closeNow();b.focus();}

function inject(){
if(!DATA.length||document.querySelector(".dhtmn-bar"))return;
/* A header section reload removes the bar but not the panels, which live on
   <body>. Sweep the orphans first, otherwise the rebuilt bar would point
   aria-controls at stale duplicates of its own panel ids. */
Array.prototype.forEach.call(document.querySelectorAll(".dhtmn-panel"),function(p){p.parentNode&&p.parentNode.removeChild(p);});
current=null;
var nav=document.querySelector(".header .main-nav")||document.querySelector(".main-nav");
bar=el("nav","dhtmn-bar");
/* el() takes no attributes, so the landmark's accessible name is set here.
   Six of the page's seven navigation landmarks are already named; this is the
   category bar, and without a name a screen reader lists it as a bare
   "navigation". Named for what it does for a shopper, in the same plain
   sentence-case register as "Primary", "Breadcrumbs" and the rest. Only one
   nav is built here — below 769px the bar is display:none and the theme's own
   drawer nav takes over — so there is no second landmark to disambiguate. */
bar.setAttribute("aria-label","Shop by category");
var inner=el("div","dhtmn-inner");
DATA.forEach(function(dep,i){
var item=el("div","dhtmn-item");
var btn=el("a","dhtmn-btn",esc(dep.n)+((dep.s||[]).length?' <span class="dhtmn-car">&#9662;</span>':''));
btn.href=BASE+dep.h;item.appendChild(btn);
var panel=el("div","dhtmn-panel",panelHTML(dep));
/* Index-prefixed so the id is unique even if two departments ever share a
   handle; the handle is kept because it makes the id readable in dev tools. */
panel.id="dhtmn-panel-"+i+(slug(dep.h)?"-"+slug(dep.h):"");
panel.setAttribute("role","group");
panel.setAttribute("aria-label",dep.n+" categories");
panel.setAttribute("aria-hidden","true");
btn.setAttribute("aria-haspopup","true");
btn.setAttribute("aria-expanded","false");
btn.setAttribute("aria-controls",panel.id);
document.body.appendChild(panel);
item.addEventListener("mouseenter",function(){openP(item,panel,btn);});
item.addEventListener("mouseleave",scheduleClose);
panel.addEventListener("mouseenter",function(){pointerInPanel=true;keep();});
panel.addEventListener("mouseleave",function(){pointerInPanel=false;scheduleClose();});

/* Keyboard. The trigger is a real link to the department collection and stays
   one: a trade buyer who knows where they are going presses Enter and lands on
   /collections/<department>. So the two jobs are split deliberately —
     - focusin reveals the panel, and ArrowDown reveals it and steps into its
       first link (ArrowDown preventDefaults, so it opens without navigating and
       without scrolling the page),
     - Enter and Space navigate, exactly as they do for a mouse user who clicks
       the trigger. Space is preventDefaulted only to stop the browser's default
       page-scroll and is then re-issued as a click, so it navigates like Enter.
   Because focus alone opens the panel, its ~60 links become reachable without
   the user ever having to guess at a key. */
btn.addEventListener("focusin",function(){openP(item,panel,btn);});
btn.addEventListener("keydown",function(e){
var k=e.key;
if(k==="Escape"||k==="Esc"){if(current&&current.item===item){e.preventDefault();closeNow();btn.focus();}return;}
if(k==="ArrowDown"||k==="Down"){e.preventDefault();openP(item,panel,btn);var f=links(panel)[0];if(f)f.focus();return;}
if(k===" "||k==="Spacebar"){e.preventDefault();openP(item,panel,btn);btn.click();return;}
if(k==="Enter"){openP(item,panel,btn);return;}
/* The panels are appended to <body> after <main> and the footer, so the raw
   tab order sends the next Tab to the following department instead of into the
   panel the user can see. Relocating the panel into the bar was rejected: the
   bar is position:relative with a z-index (a stacking context) and its z-index
   is dropped to 0 while predictive-search is open, and the panel's
   position:fixed geometry depends on no ancestor establishing a containing
   block — moving it would put all of that documented work at risk. Instead the
   tab order is corrected explicitly here: Tab off an open trigger hands focus
   to the panel's first link, and the panel's own handler hands it back out. */
if(k==="Tab"&&!e.shiftKey&&current&&current.item===item){var first=links(panel)[0];if(first){e.preventDefault();first.focus();}}
});
panel.addEventListener("keydown",function(e){
var k=e.key;
if(k==="Escape"||k==="Esc"){e.preventDefault();closeToTrigger();return;}
if(k!=="Tab")return;
var l=links(panel);if(!l.length)return;
if(e.shiftKey){if(e.target===l[0]){e.preventDefault();btn.focus();}return;}
if(e.target===l[l.length-1]){
/* Tab off the last link closes the panel and resumes the bar's own order at
   the next department. If this is the last item in the bar there is nothing to
   resume: leave the default Tab alone and let the focusout handler below do the
   closing, so we never hide the focused link out from under the browser. */
var nx=item.nextElementSibling&&item.nextElementSibling.querySelector(".dhtmn-btn");
if(nx){e.preventDefault();closeNow();nx.focus();}}
});
/* focusout with a relatedTarget containment check, rather than a blur timeout:
   relatedTarget is the element about to receive focus, so movement between the
   trigger and its own panel is ignored and anything else closes immediately. */
function outside(e){var rt=e.relatedTarget;if(rt&&(item.contains(rt)||panel.contains(rt)))return;if(current&&current.item===item)closeNow();}
item.addEventListener("focusout",outside);
panel.addEventListener("focusout",outside);

inner.appendChild(item);});
/* Clearance CTA: last in the row, no panel, no hover handlers. */
var cta=window.DHTMN_CTA;
if(cta&&cta.h){var ci=el("div","dhtmn-item dhtmn-item--clearance");var cb=el("a","dhtmn-btn",esc(cta.n));cb.href=cta.h;ci.appendChild(cb);inner.appendChild(ci);}
bar.appendChild(inner);
if(nav&&nav.parentNode){nav.parentNode.insertBefore(bar,nav);}else{var hd=document.querySelector(".header")||document.querySelector("header");if(hd){hd.appendChild(bar);}else{return;}}
document.body.classList.add("dhtmn-on");
inner.addEventListener("scroll",scrollCue,{passive:true});
scrollCue();
/* inject() runs again after a header section reload, so the document- and
   window-level listeners are wired exactly once or they would stack up. */
if(wired)return;wired=true;
window.addEventListener("resize",scrollCue);
document.addEventListener("focusin",function(e){if(e.target.closest&&e.target.closest("predictive-search"))closeNow();});
/* The panel is fixed and 370px tall, so a wheel gesture aimed at the panel is
   still a window scroll — closing on every scroll made the panel impossible to
   read. Keep it open while the pointer or focus is inside it and just re-pin it
   to the bar; close only for scrolls that happen elsewhere on the page. */
window.addEventListener("scroll",function(){if(!current)return;if(pointerInPanel||focusInside()){position(current.panel);return;}closeNow();},{passive:true});
window.addEventListener("resize",closeNow);}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",inject);}else{inject();}
document.addEventListener("shopify:section:load",inject);
})();


(function () {
  function setMobileSearchState(header, content) {
    var isMobile = window.matchMedia("(max-width: 768.98px)").matches;
    var searchHasFocus = !!header.querySelector(".header__search:focus-within");
    header.classList.toggle(
      "dht-mobile-nav-scrolled",
      isMobile && content.scrollTop > 16 && !searchHasFocus
    );
  }

  function wireMobileSearchCollapse() {
    Array.prototype.forEach.call(document.querySelectorAll(".header"), function (header) {
      var content = header.querySelector(".main-menu__content");
      var disclosure = header.querySelector(".main-menu__disclosure");
      if (!content || content.dataset.dhtSearchScroll === "true") return;

      content.dataset.dhtSearchScroll = "true";
      var ticking = false;

      content.addEventListener(
        "scroll",
        function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            setMobileSearchState(header, content);
            ticking = false;
          });
        },
        { passive: true }
      );

      if (disclosure) {
        disclosure.addEventListener("toggle", function () {
          if (!disclosure.open) {
            content.scrollTop = 0;
            header.classList.remove("dht-mobile-nav-scrolled");
            return;
          }
          setMobileSearchState(header, content);
        });
      }

      window.addEventListener("resize", function () {
        setMobileSearchState(header, content);
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireMobileSearchCollapse);
  } else {
    wireMobileSearchCollapse();
  }

  document.addEventListener("shopify:section:load", wireMobileSearchCollapse);
})();

(function () {
  function syncNestedPanelState(header) {
    var isMobile = window.matchMedia("(max-width: 768.98px)").matches;
    var searchHasFocus = !!header.querySelector(".header__search:focus-within");
    var hasScrolledPanel = Array.prototype.some.call(
      header.querySelectorAll(".main-nav__child"),
      function (panel) { return panel.scrollTop > 16; }
    );
    header.classList.toggle(
      "dht-mobile-nav-scrolled",
      isMobile && hasScrolledPanel && !searchHasFocus
    );
  }

  function wireNestedPanels() {
    Array.prototype.forEach.call(document.querySelectorAll(".header"), function (header) {
      Array.prototype.forEach.call(header.querySelectorAll(".main-nav__child"), function (panel) {
        if (panel.dataset.dhtNestedSearchScroll === "true") return;
        panel.dataset.dhtNestedSearchScroll = "true";
        var ticking = false;
        panel.addEventListener("scroll", function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncNestedPanelState(header);
            ticking = false;
          });
        }, { passive: true });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireNestedPanels);
  } else {
    wireNestedPanels();
  }
  document.addEventListener("shopify:section:load", wireNestedPanels);
})();

(function () {
  function syncNestedPanelState(header) {
    var isMobile = window.matchMedia("(max-width: 768.98px)").matches;
    var searchHasFocus = !!header.querySelector(".header__search:focus-within");
    var hasScrolledPanel = Array.prototype.some.call(
      header.querySelectorAll(".main-nav__child"),
      function (panel) { return panel.scrollTop > 16; }
    );
    header.classList.toggle(
      "dht-mobile-nav-scrolled",
      isMobile && hasScrolledPanel && !searchHasFocus
    );
  }

  function wireNestedPanels() {
    Array.prototype.forEach.call(document.querySelectorAll(".header"), function (header) {
      Array.prototype.forEach.call(header.querySelectorAll(".main-nav__child"), function (panel) {
        if (panel.dataset.dhtNestedSearchScroll === "true") return;
        panel.dataset.dhtNestedSearchScroll = "true";
        var ticking = false;
        panel.addEventListener("scroll", function () {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () {
            syncNestedPanelState(header);
            ticking = false;
          });
        }, { passive: true });
      });
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireNestedPanels);
  } else {
    wireNestedPanels();
  }
  document.addEventListener("shopify:section:load", wireNestedPanels);
})();